/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organization_Tab_ContactsInputs */

const en_organization_tab_contacts = /** @type {(inputs: Organization_Tab_ContactsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contacts`)
};

/**
* | output |
* | --- |
* | "Contacts" |
*
* @param {Organization_Tab_ContactsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const organization_tab_contacts = /** @type {((inputs?: Organization_Tab_ContactsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organization_Tab_ContactsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_organization_tab_contacts(inputs)
});